import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'

const baseURL = process.env.VUE_APP_OTTOPAY_H2H_URL || ''
export const ottoPayAvailable = Boolean(baseURL)

export async function ottoPayRequest(operation: string, payload: any) {
  const user = firebase.auth().currentUser
  if (!baseURL || !user) throw new Error('Please sign in before using OttoPay QR settings or payments.')
  const token = await user.getIdToken()
  try {
    const client = axios.create()
    // The legacy uid header is not authentication and is outside this API's CORS contract.
    delete client.defaults.headers.common.uid
    const response = await client.post(`${baseURL}/${operation}`, payload, {
      headers: { Authorization: `Bearer ${token}` }, timeout: 30000
    })
    return response.data.data
  } catch (error) {
    // Never include Axios request/config objects: credential writes contain a private key.
    const failure: any = new Error((error.response && error.response.data && error.response.data.message) || 'OttoPay is unavailable. Reopen the same bill; do not pay again.')
    failure.retryable = !error.response || error.response.status >= 500
    throw failure
  }
}

export function openOttoPay(vm: any, data: any, cart: any = {}) {
  if (!data || !data.ottoPay || data.ottoPay.provider !== 'ottopay-h2h') return false
  const outlet = JSON.parse(localStorage.getItem('outletData') || '{}')
  const posOrderInput = { active: outlet.pos_active, posName: outlet.pos_name, mandatory: outlet.pos_order_required }
  sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
  sessionStorage.setItem('orderId', data.orderId)
  sessionStorage.setItem('cartListInfo', JSON.stringify({ posOrderInput, ...cart, totalSales: data.totalSales, payment: 'QR', payment_method: 'ottopay-h2h', selectedPayment: { text: 'QR' } }))
  sessionStorage.setItem('isPos', '1')
  sessionStorage.removeItem('qrCode')
  sessionStorage.removeItem('leftTime')
  sessionStorage.removeItem('timeout')
  vm.submitLoading = false
  vm.$router.push('/pos-qr')
  return true
}

export function needsOttoQR(selectedPayment: string, readiness: any) {
  if (readiness.hasAttempt && readiness.state === 'rejected' && readiness.fallbackAllowed === true) return false
  return selectedPayment === 'QR' ? Boolean(readiness.enabled) : Boolean(readiness.hasAttempt && readiness.state !== 'failed')
}

export function findOttoReceipt(rows: any[], orderId: string) {
  return Array.isArray(rows) ? rows.find(row => (row.orderId || row.order_id) === orderId) : undefined
}
